<div id="login-bg-image" class="login-bg-image tb--background bgStyle" data-se="login-bg-image"></div>
<footer></footer>
<div id="notfound">
    <div *ngIf="!accessDenied" class="notfound">
            <h1 class="mb-4">Page Not Found</h1>
        <p>
            The page you are looking for doesn't exist or another error occurred.<br/>
            Go to the <a href="/home">Home Page</a>.
        </p>
    </div>
    <div *ngIf="accessDenied" class="notfound">
        <h1 class="mb-4">Access Denied</h1>
        <p>
            You do not have permission to access this page.<br/>
            Please contact your Site Administrator to request access.<br/>
            Go to the <a href="/home">Home Page</a>.
        </p>
    </div>
</div>